import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import FooterHome from './footerHome';
import QAItem from './qaItem';
import useWindowSize from '../../hooks/useWindowSize';
import {useSelector, useDispatch} from 'react-redux';
import allActions from '../../actions';
import { formatShortDateEnUs } from '../../utils/formatDatetime';
import { formatData } from '../../utils/StringHelper';
import { Loader } from '../common/component';

const Home = () => {
    const dispatch = useDispatch();
    const [loadingPage, setLoadingPage] = useState(false);
    const [campaignPrices, setCampaignPrices] = useState([]);
    const size = useWindowSize();
    const status = 'COMPLETED';
    const sort = 'endJoinPool,desc';

    useEffect(() => {
        setLoadingPage(true);
        dispatch(allActions.campaignAction.getCampaignsByStatus({status, sort, page: 0, size: 4}, (res) => {
            if(res.callResult === true) {
                dispatch(allActions.campaignAction.getPriceMarket(res.campaignList, (res)=>{
                    setCampaignPrices(res?.data);
                })); 
                setLoadingPage(false);
            }
        }));
      
    }, [dispatch]);

    const campaignsData = useSelector(state => state.campaignsData.campaignList);

    const handleBanner = () => {
        let img = '';
        if(size.width >= 1024) {
            img = 'new-banner-home.png';
        } else if(size.width >= 767) {
            img = 'new-banner-home-tablet.png';
        } else {
            img = 'new-banner-home-sp.png';
        }
        return img;
    }

    const elmProjectComplate = campaignsData && campaignsData.map((item, index) => {
        const d = new Date();
        d.setDate(d.getDate() - 30);
        var date = d.toISOString();

        const priceTokenArray = campaignPrices && campaignPrices.filter(function (itemPrice) {
            return itemPrice.id === item.tokenInform.tokenId;
        });

        let currentPrice = priceTokenArray && priceTokenArray[0] && priceTokenArray[0].current_price && Number(priceTokenArray[0].current_price.toFixed(5));
        const conversionRateNumber = Number(item.idoRate);
        let roiToken = (conversionRateNumber !== 0 && currentPrice > conversionRateNumber) ? (+currentPrice / conversionRateNumber)*100 : (-conversionRateNumber / currentPrice*100);
        roiToken = roiToken ? roiToken.toFixed(0) : '';

        if(date < item.endJoinPool) {
            return(
                <li key={index} className="c-listHome__item">
                    <div className="c-listHome__number"><span>{index + 1}</span></div>
                    <div className="c-listHome__name">
                        <span><img src={item.bannerURL ? item.bannerURL : '../images/og_image.jpg'} alt={item.title} /></span>
                        {item.title}
                    </div>
                    <div className="c-listHome__info is-date">
                        <span>IDO Date</span>
                        <p>{item.startIDO && formatShortDateEnUs(item.startIDO)}</p>
                    </div>
                    <div className="c-listHome__info is-token">
                        <span>Token</span>
                        <p>{item.tokenInform && item.tokenInform.symbol}</p>
                    </div>
                    <div className="c-listHome__info is-rate">
                        <span>IDO Rate</span>
                        <p>{formatData(item.idoRate, item.acceptCurrency)}</p>
                    </div>
                    <div className="c-listHome__info is-price">
                        <span>Current Price</span>
                        <p>{formatData(currentPrice, item.acceptCurrency)}</p>
                    </div>
                    <div className="c-listHome__info is-roi">
                        <span>ROI</span>
                        {roiToken && currentPrice !== 0 ? <p className={`${roiToken > 0 ? 'up' : ( roiToken == '' ? '' : 'down') }`}>{formatData(roiToken, '%')}</p> : <p>--</p>}
                    </div>
                </li>
            );
        }
    });
    return(
        <div className="p-home">
            {loadingPage && <Loader />}
            <div className="p-home__banner">
                <div className="p-home__head">
                    <h2>KingdomStarter LaunchPad</h2>
                    <p>Gain early access to public and special token sales at a lower price before they hit the market</p>
                </div>
                <ul>
                    <li>
                        <h3>45+</h3>
                        <img src="../images/icon-money.png" alt="" />
                        <p>Successful IDOs</p>
                    </li>
                    <li>
                        <h3>30k+</h3>
                        <img src="../images/icon-user.png" alt="" />
                        <p>Users join IDOs</p>
                    </li>
                    <li>
                        <h3>90x</h3>
                        <img src="../images/icon-graph.png" alt="" />
                        <p>ATH up to</p>
                    </li>
                </ul>
            </div>
            <div className="p-home__project">
                <h3>Completed Projects<p><span>30 days</span></p></h3>
                <ul className="c-listHome">
                    {elmProjectComplate}
                </ul>
                <div className="p-home__link">
                    <Link to={'/launchpad/completed'}>See more &gt;&gt;</Link>
                </div>
            </div>
            <div className="p-home__img">
                <img src={`../images/${handleBanner()}`} alt="" />
            </div>
            <div className="p-home__qa">
                <h3 className="p-home__ttl">Frequently<br/>Asked Questions</h3>
                <div className="c-qa">
                    <QAItem title='How can I join IDOs on KingdomStarter?'>
                        KDG has a Tier system with 5 Tiers that features various pool weights. All tiers enjoy guaranteed allocation, which means that every eligible KDG holder gets the chance to purchase the token during the IDOs.<br/>
                        So the holder chooses which Tier they want to have, stake at KingdomStarter’s staking pools to begin participating in the IDOs.<br/>
                        More details how to join IDO <a href="https://docs.kingdomgame.org/products/kingdomstarter-igo-launchpad/IGO-rules" target="_blank" rel="noopener noreferrer">HERE</a>.
                    </QAItem>
                    <QAItem title='How to stake KDG to get a tier?'>
                        KDG has a tier system to join IDOs on KingdomStarter.<br />
                        To get a tier, you need to stake at least 100,000 KDG at pool 1 and pool 2 or 6,700 KDG-BUSD LP token at pool 4 on KingdomStarter.<br/>
                        See more about KDG Tier System <a href="https://docs.kingdomstarter.io/products/kingdomstarter-igo-launchpad/staking-for-ido" target="_blank" rel="noopener noreferrer">HERE</a>.
                    </QAItem>
                    <QAItem title='Where can I buy KDG token?'>
                        Currently, <span>$KDG</span> is listed on <a href="https://www.mexc.com/" target="_blank" rel="noopener noreferrer">MEXC</a> and <a href="https://pancakeswap.finance/swap" target="_blank" rel="noopener noreferrer">PancakeSwap</a> so you can buy KDG tokens on these exchanges.
                    </QAItem>
                    <QAItem title='How does the 2-hour refund mechanism work?'>
                        - A risk-free function for investors.<br/>
                        - Applied for all IDOs in model 2 & for Guaranteed and Community round.<br/>
                        - Refund within 2 hours since TGE.<br/>
                        - If the claiming time is not scheduled, the refund button will not be displayed.<br/>
                        - Refund action will charge no fee.
                    </QAItem>
                    <QAItem title='What should I do after IDOs?'>
                        After IDOs, you should follow our media channels to keep up-to-date with the listing timeline of IDO tokens. On the listing date, don't forget to claim your tokens on time and take profits from them.
                    </QAItem>
                    <div className="p-home__link is-left">
                        <a href="https://docs.kingdomgame.org/" target="_blank" rel="noopener noreferrer">See more &gt;&gt;</a>
                    </div>
                </div>
            </div>
            <FooterHome />
        </div>
    )
}

export default Home;